import { AuthLoaderFederated } from './AuthLoaderFederated';
import { AuthLoaderForms } from './AuthLoaderForms';
import { USE_FEDERATED_AUTH } from 'config';

export const AuthLoader = ({ children }: { children: React.ReactNode }) =>
  USE_FEDERATED_AUTH ? (
    <AuthLoaderFederated>{children}</AuthLoaderFederated>
  ) : (
    <AuthLoaderForms>{children}</AuthLoaderForms>
  );
